/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tea_Grade_Search_EmptyInputs */

const vi_tea_grade_search_empty = /** @type {(inputs: Tea_Grade_Search_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không có phân loại nào khớp từ khoá đang tìm.`)
};

/**

* @param {Tea_Grade_Search_EmptyInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const tea_grade_search_empty = /** @type {((inputs?: Tea_Grade_Search_EmptyInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tea_Grade_Search_EmptyInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_tea_grade_search_empty(inputs)
});